import type { ReactNode } from "react";

type ICardContent = {
	children: ReactNode;
};

export const CardContent = ({ children }: ICardContent) => {
	return <div className="tablet:px-6 tablet:pb-6 px-4 pb-4">{children}</div>;
};
